import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum } from "@/utils/utils";
import { settleTypeDs } from "@/types/FmsDs";
import { ISCMSaleDcDetail } from "../saleDcTypes";
import { useSaleDcModel } from "../seleDcModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useSaleDcDetailsModel } from "./details/saleDcDetailsModel";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => []);
    const {
        dataSource, selectedRowKeys, pgCfg, loading, statistics,
        loadData, setSelectedRowKeys
    } = useSaleDcModel();
    const { resetEditCatch } = useSaleDcDetailsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData();
    }, [])

    const onEdit = (code: string) => {
        let SaleDcEditKey = "16-2-2";
        let isFindNav = findNav(SaleDcEditKey);
        if (!isFindNav) {
            addNav(SaleDcEditKey, { id: code as string, mode: "edit" });
            resetEditCatch()
        } else {
            globalPrompt("modal", {
                title: "调出单跳转详情",
                type: "warning",
                text: "您还有调出单单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(SaleDcEditKey, { id: code as string, mode: "edit" });
                    resetEditCatch()
                }
            })
        }
    }
    const defaultColumns: ColumnsType<ISCMSaleDcDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '调拨单号',
            width: 190,
            dataIndex: 'code',
            render: (text: any) => <YhTootip text={text} onClick={() => onEdit(text)} />,
        }, {
            title: '调出单号',
            width: 180,
            dataIndex: 'transferOutCode',
            render: (text: any) => <YhTootip text={text} />,
            // }, {
            //     title: '调入单号',
            //     width: 180,
            //     dataIndex: 'transferInCode',
            //     fixed: "left",
        }, {
            title: '调拨类型',
            width: 160,
            dataIndex: 'transferTypeName',
        }, {
            title: '调入站点',
            width: 160,
            dataIndex: 'shopName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '调出站点',
            width: 160,
            dataIndex: 'outShopName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
            // }, {
            //     title: '结算类型',
            //     width: 100,
            //     dataIndex: 'payType',
            //     render: text => settleTypeDs.find(item => item.value === text)?.label ?? ""
            // }, {
            //     title: '支付状态',
            //     width: 100,
            //     dataIndex: 'payStatus',
            //     render: text => getTreeNodeName(text)
            // }, {
            //     title: '支付方式',
            //     width: 160,
            //     dataIndex: 'payRecords',
            // render: text => {
            //     if (text && isArray(text)) {
            //         let str = text.map((item: any) => item?.payMethodName ?? "").join();
            //         return <p className="ellipsis" title={str}>{str}</p>
            //     } else {
            //         return ""
            //     }
            // }
        }, {
            title: '调拨数量',
            width: 100,
            dataIndex: 'totalNum',
        }, {
            title: '成本金额',
            width: 100,
            dataIndex: 'costAmount',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '毛利',
            width: 100,
            dataIndex: 'grossProfit',
            render: text => `￥${text}`
        }, {
            title: '应收金额',
            width: 100,
            dataIndex: 'totalAmount',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '优惠总金额',
            width: 110,
            dataIndex: 'discountTotalAmount',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '已收金额',
            width: 136,
            dataIndex: 'aggregateAmount',
            render: text => `￥${formatNum(text)}`
        }, {
            title: '调入实体',
            width: 160,
            dataIndex: 'bentityName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '调出实体',
            width: 160,
            dataIndex: 'outBentityName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>
        }, {
            title: '制单员',
            width: 100,
            dataIndex: 'applier',
        }, {
            title: '调出员',
            width: 100,
            dataIndex: 'transferOut',
        }, {
            title: '调入员',
            width: 100,
            dataIndex: 'transferIn',
        }, {
            title: '制单日期',
            width: 180,
            dataIndex: 'applyTime',
        }, {
            title: '调出日期',
            width: 180,
            dataIndex: 'transferOutTime',
        }, {
            title: '调入日期',
            width: 180,
            dataIndex: 'transferInTime',
        }, {
            title: '备注',
            width: 180,
            dataIndex: 'note',
        }, {
            title: '打印次数',
            width: 80,
            align: "center",
            // fixed: "right",
            dataIndex: 'printNum',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "saleOut", "roleCodes": roles };
        return getRoleColumns("saleOut", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 370px)" }}
            summary={() => (
                <Table.Summary fixed>
                    <Table.Summary.Row className="table-total-box">
                        <Table.Summary.Cell index={0}>
                            <div className="title">合计</div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} />
                        <Table.Summary.Cell index={4} />
                        <Table.Summary.Cell index={5} />
                        <Table.Summary.Cell index={6} />
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8} >
                            <span className="red">{statistics?.totalNum}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={9} />
                        <Table.Summary.Cell index={10} />
                        <Table.Summary.Cell index={11} />
                        {/* >
                            <span className="red">{statistics?.totalAmount}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={12} />
                        <Table.Summary.Cell index={13} />
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                        <Table.Summary.Cell index={18} />
                        <Table.Summary.Cell index={19} />
                        <Table.Summary.Cell index={20} />
                        <Table.Summary.Cell index={21} />
                        <Table.Summary.Cell index={22} />
                        <Table.Summary.Cell index={23} />
                    </Table.Summary.Row>
                </Table.Summary>
            )}
        />
    )
}
